import React from 'react';
import './styles.scss';

const Gallery = props => {
  return (
    <div>
        Gallery
    </div>
  );
};

export default Gallery;